import type { OrderRefreshRate } from '@/library/OrderSettingsHelper';
import OrdersTable from './OrdersTable';
import type { OrdersPageType } from './OrdersPresentation';
import OrdersFilters from './OrdersFilters';
import OrdersPagination from './OrdersPagination';
import { ORDERS_PER_PAGE } from './OrdersQuery';
import { useOrdersDashboard } from './useOrdersDashboard';
import styles from './Orders.module.scss';

interface IProps {
  currentPage: OrdersPageType;
  refreshRate?: OrderRefreshRate;
}

export function OrdersDashboard({ currentPage, refreshRate = 5 }: IProps) {
  const { query, sortBy, orders, totalOrders, isLoading, loadFailed, highlightedIds, changeFilters, changeSort, changePage, applyDefaults, defaultsLoading } = useOrdersDashboard(
    currentPage,
    refreshRate,
  );
  let tableStatusMessage: string | undefined;
  if (isLoading) tableStatusMessage = 'Loading orders…';
  else if (loadFailed) tableStatusMessage = 'Unable to load orders.';
  else if (orders.length === 0) tableStatusMessage = 'No orders found.';

  return (
    <div className={styles.container}>
      <section>
        <div className={styles.toolbar}>
          {!defaultsLoading && <OrdersFilters currentPage={currentPage} query={query} onFiltersChange={changeFilters} onDefaults={applyDefaults} />}
          <div className={styles.tableControls}>
            <OrdersPagination offset={query.offset} pageSize={ORDERS_PER_PAGE} total={totalOrders} onOffsetChange={changePage} />
          </div>
        </div>
        <OrdersTable highlightedIds={highlightedIds} currentPage={currentPage} orders={orders} sortBy={sortBy} statusMessage={tableStatusMessage} onSortChange={changeSort} />
      </section>
    </div>
  );
}

export default OrdersDashboard;
